import { render, staticRenderFns } from "./providelist.vue?vue&type=template&id=7fa97d4a&scoped=true"
import script from "./providelist.vue?vue&type=script&lang=js"
export * from "./providelist.vue?vue&type=script&lang=js"
import style0 from "./providelist.vue?vue&type=style&index=0&id=7fa97d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa97d4a",
  null
  
)

export default component.exports